module.exports = __webpack_public_path__ + "img/button-register.7d841043.png";